import { render, staticRenderFns } from "./VesselAccessControl.vue?vue&type=template&id=be30e444&"
import script from "./VesselAccessControl.vue?vue&type=script&lang=ts&"
export * from "./VesselAccessControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports